import { create } from "zustand"
import { createJSONStorage, persist } from "zustand/middleware"

interface LayoutState {
  insetTop: number
  insetBottom: number
  loadLayout: (payload: { insetTop: number; insetBottom: number }) => Promise<void>
}

export const useLayoutStore = create<LayoutState>()(
  persist(
    (set) => ({
      insetTop: 0,
      insetBottom: 0,
      loadLayout: async ({ insetTop, insetBottom }) => {
        set({
          insetTop,
          insetBottom
        })
      }
    }),
    {
      name: "layout-storage",
      storage: createJSONStorage(() => window.localStorage)
    }
  )
)
